import { AvatarProps } from 'antd';
import { StyledAvatar } from './styles';
import { getNameInitials } from 'utils/getNameInitials';

interface Props extends AvatarProps {
    userName?: string;
}

const UserAvatar = ({ userName, ...rest }: Props) => {
    const userInitials = userName && getNameInitials(userName);
    return <StyledAvatar {...rest}>{userInitials}</StyledAvatar>;
};

export default UserAvatar;
